import type { ReactNode } from "react";
import "./ToggleButton.scss";
import type { IconComponent } from "@/shared/components/generic/IconComponentType";
import { Tooltip } from "@mui/material";
import classNames from "classnames";

interface ToggleButtonProps {
  icon?: IconComponent;
  text?: string;
  selected: boolean;
  tooltipText?: string;
  onClick: () => void;
  outlined?: boolean;
}

export default function ToggleButton(props: ToggleButtonProps): ReactNode {
  if (props.text === undefined && props.icon === undefined) {
    throw new Error("Text or icon is required");
  }

  const classes = classNames("toggle-button", {
    "color-outlined": props.outlined ?? false,
    "color-filled": !(props.outlined ?? false),
    "style-text": props.text !== undefined && props.text.length > 0,
    "style-icon": !(props.text !== undefined && props.text.length > 0),
    selected: props.selected,
  });

  return (
    <Tooltip
      title={props.tooltipText}
      placement="top"
      disableInteractive={true}
      enterDelay={800}
    >
      <div className={classes} onClick={props.onClick}>
        {props.icon && <props.icon />}
        <span>{props.text}</span>
      </div>
    </Tooltip>
  );
}
